import { render, staticRenderFns } from "./examinerSet.vue?vue&type=template&id=ba1bfede&scoped=true"
import script from "./examinerSet.vue?vue&type=script&lang=js"
export * from "./examinerSet.vue?vue&type=script&lang=js"
import style0 from "./examinerSet.vue?vue&type=style&index=0&id=ba1bfede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1bfede",
  null
  
)

export default component.exports